import { InjectionToken } from '@angular/core';

/**
 * Opens a remote document (e.g. a PDF) for the user. Takes a lazy `resolveUrl`
 * so each implementation owns its timing: the web impl must open the tab BEFORE
 * awaiting the URL to keep the user-gesture, the native impl just awaits it.
 */
export interface DocumentOpenerPort {
  open(resolveUrl: () => Promise<string>): Promise<void>;
}

export const DOCUMENT_OPENER = new InjectionToken<DocumentOpenerPort>('DOCUMENT_OPENER');
